<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :backButtonRoute="backButtonRoute"
    :gcPopupConfig="gcPopupConfig"
    ref="customer-invoice"
    class="customer-invoice"
    :paging="false"
  >
    <template #popup>
      <gcPopupInvoiceBalanceHistory
        :visible.sync="showHistory"
        :invoiceNumber="InvoiceCode"
        :customerNumber="customerCode"
        :InvoicedAmount="InvoicedAmount"
        v-if="showHistory"
      />
    </template>
  </TransactionTemplate>
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import { CommonStorage, FeatureStorage } from "../../_services/storage";
import { InvoiceCreditService } from "../../_services/api/sales/invoice-credit.service";
import { CustomerInvoiceService } from "../../_services/api/customers/customer-invoice.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { mapGetters } from "vuex";
import gcPopupInvoiceBalanceHistory from "../../popups/sales/gc-popup-invoice-balance-history.vue";

let setBackRoute = undefined;

export default {
  mixins: [RouteMixin],
  components: {
    TransactionTemplate,
    gcPopupInvoiceBalanceHistory,
  },
  beforeCreate() {
    this.$store.dispatch("defaultUserSettings/setDefaultCompanyBranchDivision");
  },
  data() {
    return {
      screenJson: undefined,
      backButtonRoute: undefined,
      gcPopupVisible: false,
      newDueDate: undefined,
      InvoiceDate: undefined,
      InvoiceMaxDate: undefined,
      InvoiceMinDate: undefined,
      InvoiceCode: undefined,
      AccountingPeriodCode: undefined,
      status: undefined,
      SalesOrder: undefined,
      DateIn: undefined,
      DueDate: undefined,
      customerCode: undefined,
      SalesOrderCode: undefined,
      showHistory: false,
      InvoicedAmount: 0,
    };
  },

  created() {
    if (CommonStorage.getItems("go_back_route"))
      this.backButtonRoute = CommonStorage.getItems("go_back_route");
    else this.backButtonRoute = setBackRoute;

    if (this.baseView.query && this.baseView.query.from)
      this.backButtonRoute = this.baseView.query.from;
  },
  mounted() {},

  computed: {
    ...mapGetters({ getHotKeyEdit: "hotKey/getHotKeyEdit" }),
    gcPopupConfig() {
      return {
        title: "Adjust Due Date",
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 400,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            screenField: "Invoice",
            dataField: "Code",
            label: {
              text: "Invoice #",
            },
          },
          {
            dataField: "CustomerName",
            label: {
              text: "Customer Name",
            },
          },
          {
            screenField: "SalesOrderCode",
            dataField: "SalesOrderCode",
            label: {
              text: "Sales Order",
            },
          },
          {
            screenField: "DateCreated",
            dataField: "DateCreated",
            label: {
              text: "Invoice Date",
            },
          },
          {
            screenField: "DueDate",
            dataField: "DateDue",
            label: {
              text: "Current Due Date",
            },
          },
          {
            screenField: "DueDate",
            dataField: "newDueDate",
            label: {
              text: "New Due Date",
            },
            editorOptions: {
              min: this.DateIn,
              max: this.InvoiceMaxDate,
              allowUpdate: true,
              onValueChanged: (e) => {
                if (e.event) this.onChangeNewDueDate(e);
              },
            },
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          disabled: !this.newDueDate,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
    getGcPopUpVisible() {
      return this.gcPopupVisible;
    },

    getScreenJson() {
      var screenJson = {
        title: "Invoice",
        endpoint: {
          primary: "Invoice",
          postProcess: this.invoicePostProcess,
          select: [
            "DateIn",
            "DateDue",
            "OrderNo",
            "AgentName",
            "AgentCommissionPcnt",
            "DeliveryAddressCompanyName",
            "BranchDescription",
            "DivisionDescription",
            "SalesOrderTypeDescription",
            "SalesRepresentativeFullName",
            "ExchangeRate",
            "CurrencyCode",
            "Code",
            "SalesOrderCode",
            "DeliveryNoteCode",
            "DateCreated",
            "CreatedBy",
            "DateChanged",
            "Status",
            "CustomerCode",
            "CustomerName",
            "SalesOrderTypeCode",
            "UserComment1",
            "UserComment2",
            "UserComment3",
            "UserComment4",
            "UserComment5",
            "UserComment6",
            "UserComment7",
            "UserComment8",
            "UserComment9",
            "UserComment10",
            "UserComment11",
            "UserComment12",
            "UserComment13",
            "UserComment14",
            "UserComment15",
            "UserComment16",
            "UserComment17",
            "UserComment18",
            "UserComment19",
            "UserComment20",
            "DeliveryAddressCompanyName",
            "DeliveryAddressCountry",
            "DeliveryAddressPostcode",
            "DeliveryAddressState",
            "DeliveryAddressStreetLine1",
            "DeliveryAddressStreetLine2",
            "DeliveryAddressSuburb",
            "FXCommissionTotal",
            "IncTaxFXTotal",
            "ExTaxFXTotal",
            "BranchCode",
            "DivisionCode",
            "SalesOrderTypeCode",
            "SalesRepresentativeCode",
          ],
        },
        headerData: {
          headerFormVisible: true,
          headerFormSplitView: true,
          headerToolbar: {
            screenName: "Invoice Review",
            pdf: this.baseView.mode == "review",
            email: this.baseView.mode == "review",
            audit: true,
            status: true,
            history: true,
            historyCallBack: this.historyCallBack,
            toolTipText: "View Invoice Balance History",
            notes: false,
            commentsAsForm: true,
            commentsTitle: "Invoice Comments",
            customButtons: [
              {
                label: "save",
                icon: "..",
                type: " ",
                click: "",
                menu: [
                  {
                    label: "Invoice Comments",
                    clickAction: "",
                  },
                ],
              },
            ],
            pdfPreviewMenuItems: {
              makeDisabled: (dataModel, previewPdfs) => {
                var items = [];
                var x = { ...dataModel };

                previewPdfs.forEach((element) => {
                  if (
                    x.DeliveryNote == 0 &&
                    element.ScreenLayoutApplicationFeatureCode ===
                      "ReportDeliveryNote"
                  )
                    element.disabled = true;
                  else element.disabled = false;

                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    Parameters: element.Parameters,
                    disabled: element.disabled,
                  });
                });

                return items;
              },
            },
            emailMenuItems: {
              referenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "Invoice",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
              makeDisabled: (dataModel, emailRecords) => {
                var items = [];
                var x = { ...dataModel };

                emailRecords.forEach((element) => {
                  if (
                    x.DeliveryNote == 0 &&
                    element.ScreenLayoutApplicationFeatureCode ===
                      "ReportDeliveryNote"
                  )
                    element.disabled = true;
                  else element.disabled = false;

                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });

                return items;
              },
            },
            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      disabled: true,
                    },
                  },
                ],
              },
            ],
            ellipsis: {
              menuItems: [
                {
                  menuText: "Adjust Due Date",
                  disabled:
                    !FeatureStorage.checkPermission("Invoice", "create") ||
                    this.status == "Paid" ||
                    this.status == "Credited",
                },
                {
                  menuText: "Credit",
                  disabled:
                    !FeatureStorage.checkPermission("Invoice", "create") ||
                    this.status == "Pending" ||
                    // this.status == "Paid"   ||
                    this.status == "Credited",
                },
                {
                  menuText: "Receipt",
                  disabled:
                    this.status == "Paid" ||
                    !FeatureStorage.checkPermission("CashReceipt", "create") ||
                    this.status == "Credited",
                },
                {
                  menuText: "Edit",
                  disabled:
                    !this.SalesOrderCode ||
                    this.status == "Pending" ||
                    this.status == "Credit" ||
                    this.status == "Paid" ||
                    !FeatureStorage.checkPermission("Invoice", "create") ||
                    this.status == "Credited",
                },
              ],
              visible: true,

              clickAction: (e) => {
                if (e.itemData.menuText == "Adjust Due Date") {
                  this.visibleGcPopUp();
                } else if (e.itemData.menuText == "Credit") {
                  this.createModeRoute();
                } else if (e.itemData.menuText == "Receipt") {
                  this.navigateToCustomerReceipt();
                } else if (e.itemData.menuText == "Edit") {
                  this.navigateToInvoiceEdit();
                }
              },
            },
            orderComments: {
              dataField: "SalesOrderTypeCode",
              endpoint: "SalesOrderType",
              toMatch: [
                "UserComment1",
                "UserComment2",
                "UserComment3",
                "UserComment4",
                "UserComment5",
                "UserComment6",
                "UserComment7",
                "UserComment8",
                "UserComment9",
                "UserComment10",
                "UserComment11",
                "UserComment12",
                "UserComment13",
                "UserComment14",
                "UserComment15",
                "UserComment16",
                "UserComment17",
                "UserComment18",
                "UserComment19",
                "UserComment20",
              ],
            },
            commentItems: [
              {
                itemType: "group",
                caption: "",
                items: [],
              },
            ],
          },
          deliveryAddressItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                    disabled: true,
                  },
                  label: {
                    text: "Name",
                  },
                },
                {
                  dataField: "DeliveryAddressStreetLine1",
                  label: { text: "Street Line 1" },
                  editorOptions: {
                    maxLength: 50,
                    disabled: true,
                  },
                },
                {
                  dataField: "DeliveryAddressStreetLine2",
                  label: { text: "Street Line 2" },
                  editorOptions: {
                    maxLength: 50,
                    disabled: true,
                  },
                },
                {
                  dataField: "DeliveryAddressSuburb",
                  label: { text: "Suburb" },
                  editorOptions: {
                    maxLength: 50,
                    disabled: true,
                  },
                },
                {
                  dataField: "DeliveryAddressState",
                  label: { text: "State" },
                  editorOptions: {
                    maxLength: 50,
                    disabled: true,
                  },
                },
                {
                  dataField: "DeliveryAddressPostcode",
                  label: { text: "Post Code" },
                  editorOptions: {
                    maxLength: 20,
                    disabled: true,
                  },
                },
                {
                  dataField: "DeliveryAddressCountry",
                  label: { text: "Country" },
                  editorOptions: {
                    maxLength: 30,
                    disabled: true,
                  },
                },
              ],
            },
          ],
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "DateIn",
                      label: { text: "Date" },
                      editorType: "dxDateBox",

                      editorOptions: {
                        disabled: true,
                        displayFormat: "dd MMM yyyy",
                      },
                    },
                    {
                      dataField: "DateDue",
                      label: { text: "Due Date" },
                      editorType: "dxDateBox",
                      editorOptions: {
                        disabled: true,
                        displayFormat: "dd MMM yyyy",
                      },
                    },
                    {
                      dataField: "OrderNo",
                      label: { text: "Cust PO" },
                      editorType: "dxTextBox",
                      editorOptions: {
                        disabled: true,
                      },
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      cssClass: "gc-invoice-agent",
                      items: [
                        {
                          dataField: "AgentName",
                          label: { text: "Agent" },
                          editorType: "dxTextBox",
                          visible: FeatureStorage.checkPermission(
                            "AgentCommission",
                            this.baseView.mode,
                          ),
                          editorOptions: {
                            disabled: true,
                          },
                        },
                        {
                          dataField: "AgentCommissionPcnt",
                          label: { text: "Commission" },
                          editorType: "dxNumberBox",
                          visible: FeatureStorage.checkPermission(
                            "AgentCommission",
                            this.baseView.mode,
                          ),
                          editorOptions: {
                            disabled: true,
                            format: "Decimal-3-2P",
                            width: 80,
                          },
                        },
                      ],
                    },
                    {
                      itemType: "group",
                      caption: "",
                      cssClass: "deliver-to",
                      items: [
                        {
                          screenField: "DeliverTo",
                          dataField: "DeliveryAddressCompanyName",
                          label: {
                            text: "Deliver To",
                          },
                          allowUpdate: false,
                        },
                        {
                          screenField: "DeliveryCompanyView",
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "BranchDescription",
                      label: { text: "Branch" },
                      editorType: "dxTextBox",
                      editorOptions: {
                        disabled: true,
                      },
                    },
                    {
                      dataField: "DivisionDescription",
                      label: { text: "Division" },
                      editorType: "dxTextBox",
                      editorOptions: {
                        disabled: true,
                      },
                    },
                    {
                      dataField: "SalesOrderTypeDescription",
                      label: { text: "SO Type" },
                      editorType: "dxTextBox",
                      editorOptions: {
                        disabled: true,
                      },
                    },
                    {
                      dataField: "SalesRepresentativeFullName",
                      label: { text: "Sales Rep" },
                      editorType: "dxTextBox",
                      editorOptions: {
                        disabled: true,
                      },
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "ExchangeRate",
                          dataField: "ExchangeRate",
                          label: { text: "Exchange Rate" },
                          editorType: "dxNumberBox",
                          editorOptions: {
                            disabled: true,
                          },
                        },
                        {
                          dataField: "CurrencyCode",
                          label: {
                            text: "Currency",
                            visible: false,
                          },
                          editorOptions: {
                            readOnly: true,
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            primary: {
              primary: {
                dataField: "Code",
                text: "Invoice #",
              },
              customFunction: (data) => {
                if (data.SalesOrderCode)
                  return `Invoice #${data.Code} for Sales Order #${data.SalesOrderCode}`;
                else return `Invoice #${data.Code}`;
              },
            },
            secondary: {
              dataField: "CustomerName",
              text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "InvoiceDetail",
              // filter: [["InvoiceCode eq " + this.baseView.id]], // This will add a extra suffix into the API request filter property
              filter: [["InvoiceCode", "=", parseInt(this.baseView.id)]],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.PostProcess,
              select: [
                "InvoiceCode",
                "ItemCode",
                "ItemDescription",
                "TaxCode",
                "SalesUM",
                "SalesUMOrderQty",
                "SalesUMQty",
                "SalesUMFXPrice",
                "DiscPcnt",
                "SalesUMNetFXPrice",
                "TaxableFXLineTotal",
                "TaxFXLineTotal",
                "FXLineTotal",
                "Comment",
                "NetFXLineTotal",
                "ItemType",
                "FXCommissionTotal",
                "TaxableFXLineTotal",
                "TaxFXLineTotal",
                "FXLineTotal",
                "IsBatchProduct",
                "LineNo",
                "SalesUMInvoiceConversion",
                "IsCommentVisible",
              ],
            },
            options: {
              selectionMode: "none",
            },
          },
          toolbar: {
            search: true,
            export: false,
            expand: true,
          },
          columns: [
            {
              screenField: "Product",
              label: "Product / Account",
              allowEditing: false,
              minWidth: ColumnWidth.ProductOrAccount.minWidth,
              dataField: "ItemCode",
              filterDataField: "ItemCode",
              gridDataField: "ItemCode",
              filterIndex: 0,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ItemDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "ItemCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ItemCode",
                  label: "Item",
                },
                {
                  dataField: "ItemDescription",
                  label: "Item Description",
                },
              ],
            },
            {
              screenField: "TaxCode",
              label: "Tax",
              allowEditing: false,
              width: ColumnWidth.TaxCode.width,
              minWidth: ColumnWidth.TaxCode.minWidth,
              cellTemplate: undefined,
            },
            {
              screenField: "SalesUM",
              allowEditing: false,
              width: ColumnWidth.UnitOfMeasure.width,
              minWidth: ColumnWidth.UnitOfMeasure.minWidth,
            },
            {
              screenField: "SalesUMOrderQty",
              gridDataField: "SalesUMOrderQty",
              allowEditing: false,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              format: "Decimal-16-4",
            },
            {
              screenField: "SalesUMInvoicedQty",
              gridDataField: "SalesUMQty",
              allowEditing: false,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              format: "Decimal-16-4",
            },
            {
              screenField: "SalesUMFXPrice",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "DiscountPercent",
              allowEditing: false,
              width: ColumnWidth.Percentage.width,
              minWidth: ColumnWidth.Percentage.minWidth,
            },
            {
              screenField: "SalesUMNetFXPrice",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "TaxableFXLineTotal",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXLineTotal",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "IncTaxFXTotal",
              dataField: "FXLineTotal",
              label: "Inc Tax (Customer Currency)",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              showInColumnChooser: false,
              visible: false,
              allowEditing: false,
            },
            {
              screenField: "Comments",
              dataField: "Comment",
              allowEditing: false,
              minWidth: ColumnWidth.Comment.minWidth,
              width: ColumnWidth.Comment.width,
            },
          ],
          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "Comment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      height: "140",
                      maxLength: 1000,
                      disabled: true,
                    },
                  },
                ],
              },
            ],
          },
          childColumns: [
            {
              screenField: "Batch",
              gridDataField: "BatchNo",
              allowEditing: false,
            },

            {
              screenField: "Supplier",
              allowEditing: false,
              gridDataField: "SupplierCode",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
            },
            {
              screenField: "UseByDate",
              allowEditing: false,
            },
            {
              screenField: "SalesUMInvoicedQty",
              gridDataField: "SalesUMBatchQty",
              allowEditing: false,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              format: "Decimal-16-4",
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField: "SalesUMQty",
              location: "left",
              value: 0,
            },
            {
              screenField: "FXTotal",
              dataField: "FXCommissionTotal",
              location: "left",
              label: "Commission Payable (Customer Currency)",
              visible: FeatureStorage.checkPermission(
                "AgentCommission",
                this.baseView.mode,
              ),
              customCalc: (headerData, gridItems) => {
                var total = 0;
                if (this.baseView.mode == "review") {
                  total = headerData.FXCommissionTotal.roundNumber(2);
                } else {
                  gridItems.forEach((element) => {
                    element.FXCommissionTotal =
                      headerData.AgentCommissionPcnt *
                      (element.NetFXLineTotal / 100);

                    if (element.ItemType == "G") element.FXCommissionTotal = 0;
                    total = total + element.FXCommissionTotal.roundNumber(2);
                  });
                }
                return total;
              },
            },
            {
              screenField: "TaxableFXTotal",
              dataField: "TaxableFXLineTotal",
              location: "right",
              label: "Sub Total (Customer Currency)",
              value: 0,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXLineTotal",
              location: "right",
              value: 0,
            },
            {
              screenField: "FXTotal",
              dataField: "FXLineTotal",
              location: "right",
              label: "Total (Customer Currency)",
              value: 0,
            },
          ],
        },
      };
      return screenJson;
    },
  },
  methods: {
    historyCallBack(data) {
      // eslint-disable-next-line no-console
      console.log("history callback from invoice: ", data); // - Remove Log afterwards
      this.InvoicedAmount = data.IncTaxFXTotal;
      this.showHistory = true;
    },
    invoicePostProcess(data) {
      data["newDueDate"] = data["DateDue"];
      data["Invoice"] = data.Code;
      data["DeliveryNote"] = data.DeliveryNoteCode;
      this.status = data.Status;
      this.customerCode = data.CustomerCode;
      this.InvoiceCode = data.Code;
      this.SalesOrderCode = data.SalesOrderCode;
      data.SalesOrderCode = +data.SalesOrderCode;

      data.BranchDescription = data.BranchCode + " - " + data.BranchDescription;
      data.DivisionDescription =
        data.DivisionCode + " - " + data.DivisionDescription;
      data.SalesOrderTypeDescription =
        data.SalesOrderTypeCode + " - " + data.SalesOrderTypeDescription;
      data.SalesRepresentativeFullName =
        data.SalesRepresentativeCode +
        " - " +
        data.SalesRepresentativeFullName;

      return data;
    },

    getDueDateUpdatePayload(e) {
      var data = { ...e };

      var payload = {
        Code: data.Code,
        DueDate: new Date(data.newDueDate).toSaveDate(),
      };

      return payload;
    },
    navigateToCustomerReceipt() {
      this.$router.push({
        path: `/customer-receipt/create/${this.customerCode}`,
        query: {
          from: "invoice-order",
          invoiceNumber: this.InvoiceCode,
        },
      });
    },
    navigateToInvoiceEdit() {
      this.$router.push({
        path: `/invoice/edit/${this.InvoiceCode}`,
        query: {
          from: this.$route.fullPath,
          // invoiceNumber: this.InvoiceCode,
        },
      });
    },
    createModeRoute() {
      this.$router.push({
        path: `/credit-invoice/create/${this.baseView.id}`,
        query: {
          from: this.$router.currentRoute.fullPath,
        },
      });
    },
    PostProcess(data) {
      var items = [];
      data.forEach((element) => {
        if (element["IsBatchProduct"] != "No") {
          InvoiceCreditService.getProductBatches(
            `InvoiceCode eq ${element["InvoiceCode"]} and InvoiceLineNo eq ${element["LineNo"]}`,
            {
              select: [
                "BatchNo",
                "ItemCode",
                "StockUMQty",
                "SalesUMQty",
                "SupplierCode",
                "SupplierName",
                "InvoiceLineNo",
                "SalesUMCreditedQty",
                "UseByDate",
                "InvoiceCode",
              ],
            },
          ).then((response) => {
            element["InvoiceProductBatches"] = response.data.value.map((el) => {
              let batchLine = {
                BatchNo: el.BatchNo,
                ItemCode: el.ItemCode,
                StockUMBatchQty: el.StockUMQty,
                SalesUMBatchQty: el.SalesUMQty,
                SalesUMInvoiceConversion: element.SalesUMInvoiceConversion,
                SupplierCode: el.SupplierCode,
                SupplierName: el.SupplierName,
                InvoiceLineNo: el.InvoiceLineNo,
                SalesUMCreditedQty: el.SalesUMCreditedQty,
                UseByDate: el.UseByDate,
              };
              return batchLine;
            });
          });
        }

        items.push(element);
      });

      setTimeout(() => {
        this.$refs["customer-invoice"].$refs["transactionGrid"].reSizeGrid();
      }, 250);

      return items;
    },
    visibleGcPopUp() {
      this.DateIn = this.$refs["customer-invoice"].getTransactionData().DateIn;

      this.gcPopupVisible = true;
    },
    onChangeNewDueDate(e) {
      this.newDueDate = e.value;
    },
    gcPopupCallBack() {
      this.newDueDate = undefined;
      this.gcPopupVisible = false;
    },

    async onGcPopUpUpdate(e) {
      this.gcPopupCallBack();
      var payload = this.getDueDateUpdatePayload(e);

      this.setLoading = true;
      await CustomerInvoiceService.saveCustomerInvoiceDueDate(payload)
        .then((res) => {
          if (res) this.setLoading = false;

          this.$notify(
            `Customer Invoice #${res.data.Code} Due Date Successfully Updated`,
            "success",
          );
          e.DateDue = res.data.DueDate;

          this.$refs["supplier-invoice"].$refs[
            "gc-header-form-component"
          ].$refs["gc-header-form"].formRepaint();
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
        });
    },
  },
  watch: {
    getHotKeyEdit(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeyEdit", false);
        if (
          this.SalesOrderCode &&
          this.status != "Pending" &&
          this.status != "Credit" &&
          this.status != "Paid" &&
          FeatureStorage.checkPermission("Invoice", "create")
        ) {
          this.navigateToInvoiceEdit();
        }
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    if (
      from.fullPath != "/" &&
      from.name != "customer-receipt" &&
      from.name != "invoice-credit-create" &&
      from.name != "invoice-create"
    ) {
      setBackRoute = from.fullPath;
      CommonStorage.saveItems("go_back_route", from.fullPath);
    } else {
      setBackRoute = "/invoiced-order";
      CommonStorage.saveItems("go_back_route", "/invoiced-order");
    }
    next();
  },
};
</script>
